import type { ModalProps } from 'antd';

/** Caps a modal to the viewport: header and footer keep their size, the body scrolls. */
export const viewportCappedModalStyles: ModalProps['styles'] = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		// 16px breathing room above and below a centered modal.
		maxHeight: 'calc(100vh - 32px)',
	},
	body: {
		flex: '1 1 auto',
		// Without min-height: 0 a flex item will not shrink below its content, defeating the cap.
		minHeight: 0,
		overflowY: 'auto',
		// overflow-y: auto would otherwise promote overflow-x to auto and show a stray
		// horizontal scrollbar from negative-margin children such as <Row gutter>.
		overflowX: 'clip',
	},
};
